import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

import { pageViewSeo } from 'composition/tracking/analytics'
import { synerisePageVisit } from 'lib/synerise'
import { getCustomMetaData } from 'modules/products'

const MAX_DELAY = 4000
const CHECK_INTERVAL = 200

const sendEvent = (pathname: string) => {
  const additionalMetaData = getCustomMetaData()

  synerisePageVisit(pathname, additionalMetaData)
  pageViewSeo(pathname)
}

export const usePageTracking = () => {
  const pathname = usePathname()

  useEffect(() => {
    let isEventTriggered = false
    let timeout: NodeJS.Timeout | null = null
    let checkInterval: NodeJS.Timeout | null = null

    const clearTimeEvents = () => {
      if (timeout) clearTimeout(timeout)
      if (checkInterval) clearInterval(checkInterval)
      isEventTriggered = true
    }

    //////////////////////////////////////////////////////////////
    // max delay to ensure the event is triggered even if the canonical takes too long
    //////////////////////////////////////////////////////////////
    timeout = setTimeout(() => {
      if (isEventTriggered) return

      clearTimeEvents()
      sendEvent(pathname)
    }, MAX_DELAY)

    //////////////////////////////////////////////////////////////
    // check if the canonical href is changed
    //////////////////////////////////////////////////////////////

    checkInterval = setInterval(() => {
      if (isEventTriggered) {
        clearTimeEvents()

        return
      }

      const title = document.querySelector('title') as HTMLTitleElement

      if (title) {
        clearTimeEvents()
        sendEvent(pathname)
      }
    }, CHECK_INTERVAL)

    return () => {
      clearTimeEvents()
    }
  }, [pathname])
}
